// extracted by mini-css-extract-plugin
export default {"trigger":"css_trigger__iFb0j","triggerText":"css_triggerText__6rUcH","icon":"css_icon__PzVRE","iconOpen":"css_iconOpen__goVb6","accordion":"css_accordion__cdCIV"};